import { render, staticRenderFns } from "./feedKitchen.vue?vue&type=template&id=7083f8bb&scoped=true"
import script from "./feedKitchen.vue?vue&type=script&lang=js"
export * from "./feedKitchen.vue?vue&type=script&lang=js"
import style0 from "./feedKitchen.vue?vue&type=style&index=0&id=7083f8bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7083f8bb",
  null
  
)

export default component.exports